import * as React from "react";
import EventTypeLabel from "components/events/events/EventTypeLabel";
import PriorityName from "components/events/events/PriorityName";
const FilterValueRenderers = {
  alert: (value) => /* @__PURE__ */ React.createElement(EventTypeLabel, { isAlert: value === "true" }),
  priority: (value) => /* @__PURE__ */ React.createElement(PriorityName, { priority: value })
};
export default FilterValueRenderers;
